import React from "react";

import { TableBodyContext } from "commons/context/tableBody";

import { Column } from "commons/types/table";

export type PropsType<T> = {
    readonly rows: Array<JSX.Element>;
    readonly loading: boolean;
    readonly columns: Array<Column<T>>;
    readonly showExtraRowsWhenEmpty: boolean;
    readonly showRowWhenEmpty?: boolean;
    readonly extraRowsOnTop?: JSX.Element;
    readonly extraRows?: JSX.Element;
    readonly hideTableHead?: boolean;
};

function TableBody<T>({
    rows,
    loading,
    columns,
    showExtraRowsWhenEmpty,
    showRowWhenEmpty = true,
    extraRowsOnTop,
    extraRows,
    hideTableHead = false,
}: PropsType<T>) {
    const tableBodyContextValue = React.useMemo(
        () => ({ dataLength: rows.length, columns }),
        [rows.length, columns]
    );

    return (
        <TableBodyContext.Provider value={tableBodyContextValue}>
            <tbody>
                {!loading ? extraRowsOnTop : null}

                {rows.length === 0 && loading && (
                    <tr role="checkbox" aria-checked={false} tabIndex={-1} key={"loading-table"}>
                        <td colSpan={columns.length} style={{ textAlign: "center" }}>
                            {"Caricamento..."}
                        </td>
                    </tr>
                )}

                {rows.length === 0 && !loading && showRowWhenEmpty && (
                    <tr role="checkbox" aria-checked={false} tabIndex={-1} key={"empty-table"}>
                        {columns.map((column) => (
                            <td
                                key={column.id}
                                style={{
                                    textAlign: column.align ? column.align : "left",
                                    padding: column.padding,
                                    width: hideTableHead && column.width ? column.width : undefined,
                                }}
                                colSpan={column?.colSpan ?? 1}
                            >
                                {"-"}
                            </td>
                        ))}
                    </tr>
                )}

                {rows.length === 0 && !loading && showExtraRowsWhenEmpty ? extraRows : null}

                {rows.length > 0 && rows}

                {rows.length > 0 ? extraRows : null}
            </tbody>
        </TableBodyContext.Provider>
    );
}

export default TableBody;
